module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped tabela"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.dados), function(a, index) {
    return (index < _vm.num) ? _c('tr', {
      attrs: {
        "a": a,
        "index": index
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(a.dorsal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(a.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(a.escalao))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(a.equipa))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(a.tempo))])]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Dorsal")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Escalão")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Equipa")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Tempo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c8ac9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabelas/TabelaCompleta.vue
// module id = 246
// module chunks = 1